<template>
  <div class="selectbox">
    <div class="addressnum">
      {{ $t("home.multipleChains.addressLabel") }}{{ addresslength }}
    </div>
    <div class="addresslist" v-for="(item, index) in addressarray" :key="index">
      <div class="addresstext" @click="addressdetails(item)">
        <div class="leftimg">
          <img :src="item.tagIconUrl" alt="" />
        </div>
        <div class="righttext">
          <div class="adddressstyle">
            {{ item.address }}
          </div>
          <span class="chainstyle">
            <img :src="item.blockchain.label.iconUrl" alt="" />
            <span>{{ item.blockchain.label.name }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["addressarray", "addresslength", "selectwidth"],
  data() {
    return {};
  },
  watch: {
    // 监听语言变化，强制更新组件
    "$i18n.locale"() {
      this.$forceUpdate();
    },
  },
  methods: {
    addressdetails(v) {
      this.$emit("handlejumpdetails", v);
    },
  },
  mounted() {
    console.log("我是宽度");
    console.log(this.selectwidth);
    console.log(this.addressarray);
    let selectbox = document.querySelector(".selectbox");
    console.log(selectbox);
    selectbox.style.width = `${this.selectwidth}px`;
    // selectbox.style.width = "720px";
  },
};
</script>
<style lang="less" scoped>
.selectbox {
  position: absolute;
  top: calc(100% - 26px);
  left: 50%;
  transform: translateX(-50%);
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
  background: rgba(15, 23, 42, 0.98);
  backdrop-filter: blur(25px);
  display: inline-flex;
  padding: 12px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  z-index: 2100;

  .addressnum {
    color: rgba(255, 255, 255, 0.3);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 4px 16px 8px;
  }

  .addresslist {
    width: 100%;

    .addresstext {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      box-sizing: border-box;
      width: 100%;
      cursor: pointer;
      // border-radius: 12px;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.06);
      }

      .leftimg {
        width: 34px;
        height: 34px;

        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 12px;
        overflow: hidden;
        border: 1px solid rgba(107, 119, 138, 0.4);
        img {
          height: 34px;
          width: 34px;
          object-fit: contain;
        }
      }

      .righttext {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        .adddressstyle {
          color: #e2e8f0;
          font-size: 13px;
          font-weight: 500;
          font-family: ui-monospace, monospace;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .chainstyle {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 2px 8px;
          background: rgba(255, 255, 255, 0.08);
          border: none;
          border-radius: 4px;
          height: auto;
          width: auto;
          flex-shrink: 0;

          img {
            height: 14px;
            width: 14px;
            object-fit: contain;
          }

          span {
            color: rgba(209, 213, 219, 0.7);
            font-size: 11px;
            font-weight: 500;
            font-family: inherit;
            text-transform: capitalize;
          }
        }
      }
    }
  }
}
</style>
